if (!customElements.get('card-product-slider')) {
  class CardProductSlider extends HTMLElement {
    constructor() {
      super();

      const swiperOptions =
        JSON.parse(this.getAttribute('data-swiper-options')) || {};

      this.sliderWrapper = this.querySelector('.swiper-wrapper');
      this.requiresFetch = this.hasAttribute('data-url');
      // 🔴 [중요] card-product-slider 자체에도 data-section-id 가 박혀있어서
      // this.closest('[data-section-id]') 는 자기 자신을 반환 (closest 는 self 포함).
      // parentElement 부터 시작해야 진짜 바깥 wrapper (.section.product-feed) 가 잡힘.
      this.parent = this.parentElement?.closest('[data-section-id]') || this.closest('[data-section-id]');
      this.sliderOptions = {
        a11y: false,
        threshold: 3,
        spaceBetween: swiperOptions.spaceBetweenMobile || 2,
        slidesPerView: swiperOptions.slidesPerViewMobile || 'auto',
        resistanceRatio: 0.72,
        breakpoints: {
          750: {
            slidesPerView: 3,
            spaceBetween: swiperOptions.spaceBetweenDesktop || 2
          },
          1100: {
            slidesPerView: 4,
            spaceBetween: swiperOptions.spaceBetweenDesktop || 2
          }
        }
      };
      if (swiperOptions.navigation) {
        this.sliderOptions.navigation = {
          ...swiperOptions.navigation
        };
      }
      if (swiperOptions.autoplay) {
        this.sliderOptions.autoplay = {
          ...swiperOptions.autoplay
        };
      }
      if (swiperOptions.loop) {
        this.sliderOptions.loop = swiperOptions.loop;
      }
    }

    connectedCallback() {
      // [TEMP] 카트: 브랜드별 추천 URL 분기 — body.brand--* 와 매칭되는 URL 을 data-url 로 승격.
      // 매칭 URL 없으면(=해당 브랜드 cart item 없음) fetch 스킵 → 섹션 hidden 유지.
      // 도메인 분리 후 본 블록 + data-url-mtk/mfg 제거.
      const urlMtk = this.getAttribute('data-url-mtk');
      const urlMfg = this.getAttribute('data-url-mfg');
      if (urlMtk || urlMfg) {
        const isMarithe = document.body.classList.contains('brand--marithe');
        const pickedUrl = isMarithe ? urlMfg : urlMtk;
        if (pickedUrl) {
          this.setAttribute('data-url', pickedUrl);
          this.requiresFetch = true;
        } else {
          // 매칭 브랜드 cart item 없음 — fetch 안 함 (섹션 recommendations-loading 유지로 hidden)
          this.requiresFetch = false;
          return;
        }
      }
      if (this.requiresFetch) {
        this.fetchItems();
        return;
      }
      this.initSlider();
      this.syncHeights();
      window.addEventListener("resize", () => this.syncHeights());
    }

    syncHeights() {
      const textSlide = this.querySelector('.products-feed__card-text-custom-slide');
      const actionElement = this.querySelector('.product-card__actions');

      if (textSlide && actionElement) {
        const actionHeight = actionElement.offsetHeight;
        textSlide.style.height = `${actionHeight}px`;
      }
    }

    fetchItems() {
      if (!this.parent) throw new Error('Parent is missing');
      fetch(this.getAttribute('data-url'))
        .then(response => response.text())
        .then(text => {
          const html = new DOMParser().parseFromString(
            text,
            'text/html'
          );
          const wrapper = html.querySelector('.swiper-wrapper');

          if (wrapper && wrapper.innerHTML.trim().length) {
            this.querySelector('.swiper-wrapper').innerHTML =
              wrapper.innerHTML;
            // [TEMP] 추천 섹션 브랜드 필터 — 카트 등 SSR vendor 신호 없는 페이지 대응.
            // body.brand--* 와 다른 vendor 슬라이드 제거 후 swiper init.
            // 헤더/푸터 dual-render + CSS 토글 패턴과 동일한 SSOT(body class) 사용.
            // 도메인 분리 후 본 블록 + data-vendor 제거. wiki/docs/multi-brand-element-css-toggle-pattern.md
            this._filterSlidesByBrand();
            // 필터 후 슬라이드 0개면 추천 섹션 숨김 (빈 슬라이더 노출 방지)
            if (!this.querySelector('.swiper-wrapper').children.length) {
              this.parent.classList.add('is-empty-recommendations');
              return;
            }
            this.parent.classList.remove('hidden', 'recommendations-loading');
            this.initSlider();
          } else {
            // 🔴 추천 결과 0개 — 섹션 영구 숨김.
            // Shopify Recommendations API 가 빈 결과 반환 시 (학습 데이터 부족·신규 상품·스테이징
            // 트래픽 부족 등). 초기 .recommendations-loading 은 그대로 두고 추가 클래스 박음
            // (둘 다 display:none 이므로 어느 쪽이든 숨김 상태 유지).
            // CSS: component-card-product-slider.css
            this.parent.classList.add('is-empty-recommendations');
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    // [TEMP] body.brand--* 기준 다른 vendor 슬라이드 제거.
    // SSR 시 vendor 신호 없는 cart/checkout 등 페이지에서 사용.
    // body class 가 곧 SSOT (sessionStorage swap 후 시점에 호출되도록 fetchItems 안에서만 사용).
    _filterSlidesByBrand() {
      const body = document.body;
      let activeVendor = null;
      if (body.classList.contains('brand--marithe')) activeVendor = 'MARITHE';
      else if (body.classList.contains('brand--matinkim')) activeVendor = 'MATIN KIM';
      if (!activeVendor) return;
      const wrapper = this.querySelector('.swiper-wrapper');
      if (!wrapper) return;
      wrapper.querySelectorAll('.swiper-slide').forEach((slide) => {
        const v = slide.getAttribute('data-vendor');
        if (v && v !== activeVendor) slide.remove();
      });
    }

    initSlider(slider = this) {
      this.slider = new Swiper(slider, this.sliderOptions);

      this.slider.wrapperEl.setAttribute('aria-live', 'polite');
      this.slider.wrapperEl.id = `swiper-wrapper-${this.dataset.sectionId}`;
      this.slider.slides.forEach((slide, i) => {
        slide.setAttribute('role', 'group');
        slide.setAttribute(
          'aria-label',
          `${i + 1} / ${this.slider.slides.length}`
        );
        slide.dataset.index = i;
      });

      if (this.swiperOptions?.navigation) {
        const sliderButtons = [
          this.slider.navigation.prevEl,
          this.slider.navigation.nextEl
        ];

        sliderButtons.forEach((button, i) => {
          let type = 'Previous';

          if (i === 1) {
            type = 'Next';
          }

          button.setAttribute('aria-label', `${type} slide`);
          button.setAttribute(
            'aria-controls',
            this.slider.wrapperEl.id
          );
        });
      }

      this.slider.wrapperEl.addEventListener('focusin', e => {
        this.slider.el.scrollLeft = 0;

        const slide = e.target.closest('.swiper-slide');
        const slideIndex = +slide.dataset.index;
        const isFirstSlide = slideIndex === 0;
        const isLastSlide =
          slideIndex === this.slider.slides.length - 1;

        if (isFirstSlide || isLastSlide) {
          this.slider.slideTo(slideIndex, 0);

          return;
        }

        const slideRect = slide.getBoundingClientRect();
        const wrapperWidth = this.slider.wrapperEl.clientWidth;
        // prettier-ignore
        const slideLeft = slideRect.x + slideRect.width - ((document.body.clientWidth - wrapperWidth) / 2);
        const isSlideVisible =
          slideLeft <= wrapperWidth && slideLeft >= slideRect.width;

        if (isSlideVisible) {
          return;
        }

        slideLeft >= slideRect.width
          ? this.slider.slideNext(0)
          : this.slider.slidePrev(0);
      });

      const swiperOptions = JSON.parse(this.getAttribute('data-swiper-options')) || {};
      /** stop / start autoplay on hover if quick cart is not open */
      this.slider.wrapperEl.addEventListener('mouseenter', () =>
        this.slider.autoplay.stop()
      );
      this.slider.wrapperEl.addEventListener('mouseleave', () => {
        if (!this.classList.contains('product--open-on-quick-cart') && this.sliderOptions.autoplay) {
          this.slider.autoplay.start();
        }
        if (swiperOptions.autoplay === false) {
          this.slider.autoplay.stop();
        }
      });

      if (
        this.hasAttribute('data-init-quick-cart') &&
        document.querySelector('quick-cart-drawer') &&
        this.querySelector('.swiper-slide')
      ) {
        document.querySelector('quick-cart-drawer').init();
      }

      this.querySelectorAll('product-card').forEach(card => {
        card.init();
      });

      if (Shopify.designMode) {
        if (
          this.hasAttribute('data-init-quick-cart') &&
          document.querySelector('quick-cart-drawer') &&
          this.querySelector('.swiper-slide')
        ) {
          document.querySelector('quick-cart-drawer').init();
        }
      }
    }
  }

  customElements.define('card-product-slider', CardProductSlider);
}
